// extracted by mini-css-extract-plugin
export default {"sec_heading":"Images_sec_heading__5XiMs"};